<template>
  <j-modal
    :title="title"
    :width="500"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" style="margin-bottom: 0">
        <a-row v-if="appType==='platform'">
          <a-col  :md="22" :sm="8">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="margin-bottom: 10px;margin-top: 15px"
              :label="language['common.selectButton']+language['application']"
            >
              <a-select v-model="selectedApplicationCode" @change="applicationChange" allowClear  :placeholder="language['common.pleaseChoose']+language['application']">
                <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.applicationCode" allowClear>
                  {{ item.applicationNameLanguage||item.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="margin-bottom: 0"
            >
              <a-upload
                name="file"
                :multiple="false"
                :action="uploadAction"
                :showUploadList="false"
                :beforeUpload="beforeUpload"
                :headers="headers"
                @change="handleChange">
                <a-button>
                  <a-icon type="upload"/>
                  {{language['common.fileUp']}}
                </a-button>
              </a-upload>
              <a-button type="primary" icon="download" @click="ExportTemplateXls" style="left:20px">{{language['system.downloadTemplate']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="!!comments">
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="margin-bottom: 10px;margin-top: 15px"
              :label="language['common.importError']"
            >
              <div v-html="comments"
                   style="width:85%;border-radius: 5px;line-height: 1.5;border: 2px solid rgb(217, 217, 217);max-height: 30vh;overflow-y:scroll"></div>
              <!--<textarea v-model="comments" style="width:85%;border-radius: 5px;line-height: 1.5;" disabled rows="5" cols="25" maxLength="150" > </textarea>-->
            </a-form-model-item>
          </a-col>
        </a-row>



      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>

import {putAction, getFileAccessHttpUrl,getAction,postAction,downFile} from '@/api/manage';
import {applicationList} from '@/api/api'
import ARow from "ant-design-vue/es/grid/Row";
import ACol from "ant-design-vue/es/grid/Col";
import { headers } from '@/utils/request';

export default {
  name: 'UserUploadOrDownloadModal',
  components: {
    ACol,
    ARow
  },
  data() {
    return {
      errorModel:false,
      title:'',
      url:'',
      comments:'',
      model:{},
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading:false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      url: {
        upload: "",
      },
      applicationOptions:[],
      selectedApplicationCode:'',
      appType:'',
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    uploadAction() {
      return window._CONFIG['domianURL'] + this.url.upload;
    },
    headers() {
      return headers()
    },
  },
  methods: {
    applicationChange(value){
      this.url.upload = "/sys/user/downloadUserExcel/"+value
    },
    ExportTemplateXls(){
      let url = window._CONFIG['domianURL'] + "/sys/user/exportTemplateXls"
      // window.open(url);
      // window.location.href = url;
      downFile(url).then((data)=>{
        if (!data) {
          this.$message.warning(this.language['common.fileDowloadError'])
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), 'UserExcelTemplate.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', 'UserExcelTemplate.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
    beforeUpload(file) {
      if(this.url.upload === ""){
        this.$message.warning(this.language['common.pleaseChoose']+this.language['application']);
        return false;
      }
      var fileType = file.type;
      if (fileType === 'image') {
        if (fileType.indexOf('image') < 0) {
          this.$message.warning(this.language['warning.pleaseUploadImage']);
          return false;
        }
      } else if (fileType === 'file') {
        if (fileType.indexOf('image') >= 0) {
          this.$message.warning(this.language['warning.pleaseUploadFile']);
          return false;
        }
      }
      return true
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.loadData()
          this.$message.success(`${info.file.name}`+this.language['common.uploadSuccess']);
          this.close();
          this.$emit('ok');
          // let totalmap = [...info.file.response.result.total];
          // this.comments = "导入成功的数据有"+info.file.response.result.total.length+"条;\n导入失败的数据有0条;";
        } else {
          if(info.file.response.code!==200){
            this.comments = info.file.response.message;
            // this.comments = {...info.file.response.result};
          }else if(info.file.response.code==200){
            // this.comments = info.file.response.result
            // let resultMap = info.file.response.result;
            // let totalmap = [...info.file.response.result.total];
            let errormap = {...info.file.response.result};
            let v = ""
            for (var key in errormap) {
              if(v == ""){
                v = "<p style='margin-bottom: 0'><span style='color: red'>"+key+this.language['common.strip']+"："+errormap[key]+'</span></p>';
              }else{
                v = v+"<p style='margin-bottom: 0'><span style='color: red'>"+key+this.language['common.strip']+"："+errormap[key]+'</span></p>';
              }
            }
            /*map.forEach(function (value,key) {
              if(v == ""){
                v = "第"+key+"行："+value+'\n';
              }else{
                v = v+"第"+key+"行："+value+'\n';
              }
            })*/
            /*this.comments = "<p style='margin-bottom: 0'><span style='color: green'>导入成功的数据有"+(info.file.response.result.total.length-Object.keys(errormap).length)+"条;</span></p>" +
              "<p style='margin-bottom: 0'><span style='color: red'>导入失败的数据有"+Object.keys(errormap).length+"条;</span></p>" +
              "<p style='margin-bottom: 0'><span style='font-weight:bold'>导入失败的原因如下:</span></p>"+v;*/
            this.comments = "<p style='margin-bottom: 0'><span style='font-weight:bold'>导入失败:</span></p>"+v;
            // this.$message.error(`${info.file.response.message}`);
          }
          // this.errorModel = true;
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.response.message}`);
      }
    },
    add() {
      /*this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add();
      })*/
    },
    edit(application) {
      /*this.pfBpmProcessId = record.pfBpmProcessId;
      this.workNo = record.workNo;
      this.approveAction = record.approveAction;
      this.taskCode = record.taskCode;*/
      /*this.title = record.title;
      this.comments = "";
      this.url = record.url;
      this.model = Object.assign({}, record)*/
      if(application.applicationType === 'platform'){
        this.initApplicationList()
        this.url.upload = "";
        this.appType = 'platform';
      }else{
        this.url.upload = "/sys/user/downloadUserExcel/"+this.$store.getters.applicationCode
      }
      this.visible = true

    },
    initApplicationList(){
      let that = this;
      applicationList().then((res) => {
        if(res.success){
          that.applicationOptions = res.result;
        }
      })
    },
    close() {
      /*this.$emit('reSeach');
      this.$emit('close');*/
      this.visible = false;
      // this.errorModel = false;
      this.appType = '';
      this.selectedApplicationCode = '';
      this.comments = "";
    },
    handleOk() {
      // this.$refs.realForm.submitForm();
      this.close()
    },

    submitCallback() {
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>